import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import descriptografar from '@app/shared/rotinas/descriptografar';
import { Observable } from 'rxjs';

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = descriptografar(
      sessionStorage.getItem('if-carta-token') ?? ''
    );

    if (token) {
      const apiToken = { 'x-api-key': `${token}` };
      request = request.clone({ setHeaders: apiToken });
    }

    return next.handle(request);
  }
}
